export const SET_DAYS = 'SET_DAYS'
export const SET_STATUS = 'SET_STATUS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_VIEW_DASHBOARD = 'SET_VIEW_DASHBOARD'
export const SET_VIEW_SECTION = 'SET_VIEW_SECTION'
export const SET_WORK_ORDER = 'SET_WORK_ORDER'
export const SET_WORK_ORDERS = 'SET_WORK_ORDERS'
export const SET_SELECTED = 'SET_SELECTED'
export const GET_REPAIR_LINES = 'GET_REPAIR_LINES'
export const SET_WORK_ORDER_HISTORY = 'SET_WORK_ORDER_HISTORY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_STATE_DEFAULT = 'SET_STATE_DEFAULT'
export const SET_STATE_ASSEMBLY = 'SET_STATE_ASSEMBLY'
export const SET_STATE_SRS = 'SET_STATE_SRS'
export const SET_STATE_LIGHTS = 'SET_STATE_LIGHTS'
export const SET_STATE_KEY_ENGINE = 'SET_STATE_KEY_ENGINE'
export const SET_STATE_DAMAGE_LEVEL = 'SET_STATE_DAMAGE_LEVEL'
export const SET_STATE_DAMAGE_POSITION = 'SET_STATE_DAMAGE_POSITION'
export const SET_WORK_ORDER_NOTES = 'SET_WORK_ORDER_NOTES'
export const SET_WORK_ORDER_STATUS = 'SET_WORK_ORDER_STATUS'
export const SET_WORK_ORDER_SCAN_TYPE = 'SET_WORK_ORDER_SCAN_TYPE'
export const REFRESH_WORK_ORDER = 'REFRESH_WORK_ORDER'
export const SET_SHOP_DEVICE = 'SET_SHOP_DEVICE'
export const SET_HUB_DATA = 'SET_HUB_DATA'
export const SET_DISPATCH_WORK_ORDERS = 'SET_DISPATCH_WORK_ORDERS'
export const FILTER_WORK_ORDERS = 'FILTER_WORK_ORDERS'
export const UPDATE_SCAN_REPORT = 'UPDATE_SCAN_REPORT'
export const UPDATE_SCAN_REPORT_FOLLOW_UP = 'UPDATE_SCAN_REPORT_FOLLOW_UP'
export const UPDATE_SCAN_REPORT_PERFORMED_PROGRAMMING = 'UPDATE_SCAN_REPORT_PERFORMED_PROGRAMMING'
export const SET_WORK_ORDER_SCHEDULE = 'SET_WORK_ORDER_SCHEDULE'
export const SET_MOBILE_HANDOFF = 'SET_MOBILE_HANDOFF'
export const SET_WORKORDER_ASSIGNMENT = 'SET_WORKORDER_ASSIGNMENT'
export const SET_DEVICE_STATISTIC_INTERVAL = 'SET_DEVICE_STATISTIC_INTERVAL'
export const SET_WORKORDER_VEHICLE = 'SET_WORKORDER_VEHICLE'
export const SET_TEAM_ONLY_VIEW = 'SET_TEAM_ONLY_VIEW'
export const SET_COMPLETED_ONLY_VIEW = 'SET_COMPLETED_ONLY_VIEW'
export const SET_NEW_WORK_ORDER = 'SET_NEW_WORK_ORDER'
export const SET_WORK_ORDER_LOCATION = 'SET_WORK_ORDER_LOCATION'
export const SET_WORK_ORDER_DEVICES = 'SET_WORK_ORDER_DEVICES'
export const SET_DEVICE_PROTOCOL = 'SET_DEVICE_PROTOCOL'
export const SET_DEVICE_INTERFACE = 'SET_DEVICE_INTERFACE'
export const SET_SEARCH_COMPLETED = 'SET_SEARCH_COMPLETED'
export const RESET_COMPLETED_ONLY_VIEW = 'RESET_COMPLETED_ONLY_VIEW'

export const WORKORDER_ORDER_BY = 'workOrder/orderBy'
export const WORKORDER_SORT_DIR = 'workOrder/sortDir'
export const WORKORDER_DAYS = 'workOrder/days'
export const WORKORDER_STATUS = 'workOrder/status'
export const WORKORDER_PAGE_SIZE = 'workOrder/pageSize'
export const WORKORDER_SEARCH_TERM = 'workOrder/searchTerm'
export const WORKORDER_FILTER_BY = 'workOrder/filterBy'
export const SET_TOOLBARMENU_REQUEST_HELP = 'SET_TOOLBARMENU_REQUEST_HELP'



// WEBPACK FOOTER //
// ./src/store/modules/work-orders/types.js